import { render } from "./PhoneLogin.vue?vue&type=template&id=c54cdf92&scoped=true"
import script from "./PhoneLogin.vue?vue&type=script&lang=js"
export * from "./PhoneLogin.vue?vue&type=script&lang=js"

import "./PhoneLogin.vue?vue&type=style&index=0&id=c54cdf92&lang=less&scoped=true"
import "./PhoneLogin.vue?vue&type=style&index=1&id=c54cdf92&lang=less"

import exportComponent from "/home/data/jenkins/workspace/Pro_TWI_T/Pro_TWI_h5_advantrade-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c54cdf92"]])

export default __exports__